const {
  Bot,
  Building2,
  ChartNoAxesCombined,
  Code2,
  DatabaseZap,
  Globe2,
  Handshake,
  Link2,
  MessagesSquare,
  PanelsTopLeft,
  ShoppingCart,
  Workflow,
} = require("lucide-react");
const { buildWhatsappLink } = require("./constants");

const positioning = {
  eyebrow: "Web. Systems. Automation.",
  headline: "Tecnologia para empresas venderem, automatizarem e operarem melhor.",
  summary:
    "Criamos websites, sistemas e automações que ajudam empresas em Portugal a vender mais, reduzir trabalho manual e crescer com processos digitais claros.",
};

const heroPrimaryCtas = [
  {
    label: "Pedir diagnóstico gratuito",
    target: "/diagnostico-digital",
    message:
      "Olá! Quero pedir um diagnóstico digital gratuito para a minha empresa.",
    source: "hero_diagnostic",
  },
  {
    label: "Ver projetos",
    target: "/projetos",
    message:
      "Olá! Quero ver projetos da BezierClick antes de falar sobre a minha empresa.",
    source: "hero_projects",
  },
];

const heroSecondaryCta = {
  label: "Falar com um especialista",
  href: buildWhatsappLink(
    "Olá! Quero falar com um especialista da BezierClick sobre tecnologia para a minha empresa.",
    "hero_specialist"
  ),
};

const mainPillars = [
  {
    title: "Web",
    price: "desde EUR 490 + IVA",
    desc: "Websites, landing pages e ecommerce preparados para captar pedidos e gerar confiança.",
    icon: Globe2,
    href: "/solucoes",
  },
  {
    title: "Systems",
    price: "desde EUR 1.500 + IVA",
    desc: "CRM, portais, dashboards e sistemas internos para substituir Excel, papel e trabalho manual.",
    icon: Code2,
    href: "/solucoes",
  },
  {
    title: "Automation & AI",
    price: "desde EUR 290 + IVA",
    desc: "Automações, integrações e IA para ligar ferramentas, qualificar leads e acelerar operações.",
    icon: Bot,
    href: "/solucoes",
  },
  {
    title: "Tech Partner",
    price: "desde EUR 490/mês + IVA",
    desc: "Acompanhamento técnico recorrente para PMEs que precisam evoluir sem contratar uma equipa interna.",
    icon: Handshake,
    href: "/tech-partner",
  },
];

const solutionGroups = [
  {
    n: "01",
    title: "Websites e landing pages",
    price: "desde EUR 490 + IVA",
    forWho: "Empresas, serviços e campanhas que precisam de presença digital clara e conversão.",
    problems: ["Site desatualizado ou inexistente", "Poucos pedidos de contacto qualificados"],
    outcome: "Uma base online rápida, responsiva e preparada para medir visitas, leads e oportunidades.",
    icon: PanelsTopLeft,
    cta: "Falar sobre website",
    message:
      "Olá! Quero falar com a BezierClick sobre uma solução de website ou landing page para a minha empresa.",
  },
  {
    n: "02",
    title: "Ecommerce",
    price: "desde EUR 1.490 + IVA",
    forWho: "Negócios que querem vender online com pagamentos, encomendas e tracking organizados.",
    problems: ["Venda online improvisada", "Dificuldade em medir campanhas e recuperar oportunidades"],
    outcome: "Uma loja online preparada para vender, acompanhar resultados e evoluir com integrações.",
    icon: ShoppingCart,
    cta: "Falar sobre ecommerce",
    message:
      "Olá! Quero falar com a BezierClick sobre uma solução de ecommerce para vender online.",
  },
  {
    n: "03",
    title: "Software à medida",
    price: "desde EUR 1.500 + IVA",
    forWho: "PMEs que dependem de folhas Excel, processos manuais ou ferramentas que já não chegam.",
    problems: ["Orçamentos manuais", "Clientes, tarefas ou operações espalhadas por várias ferramentas"],
    outcome: "Um sistema interno, portal, CRM ou dashboard feito para o processo real da empresa.",
    icon: DatabaseZap,
    cta: "Falar sobre sistema",
    message:
      "Olá! Quero falar com a BezierClick sobre uma solução de sistema ou software à medida.",
  },
  {
    n: "04",
    title: "Automação & IA",
    price: "desde EUR 290 + IVA",
    forWho: "Equipas que repetem tarefas, perdem seguimentos ou querem responder melhor aos pedidos.",
    problems: ["Leads sem follow-up", "Tarefas repetitivas entre WhatsApp, email, CRM e folhas de cálculo"],
    outcome: "Fluxos automatizados para captar, qualificar, notificar, responder e acompanhar clientes.",
    icon: Workflow,
    cta: "Falar sobre automação",
    message:
      "Olá! Quero falar com a BezierClick sobre automação, IA ou integrações para resolver um problema da empresa.",
  },
  {
    n: "05",
    title: "Integrações",
    price: "EUR sob consulta",
    forWho: "Empresas que precisam ligar website, CRM, faturação, email, WhatsApp, analytics ou ferramentas internas.",
    problems: ["Dados duplicados", "Processos parados porque sistemas não comunicam"],
    outcome: "Ferramentas conectadas para reduzir erro, poupar tempo e dar visibilidade à operação.",
    icon: Link2,
    cta: "Falar sobre integrações",
    message:
      "Olá! Quero falar com a BezierClick sobre uma solução de integrações entre ferramentas da minha empresa.",
  },
];

const projectPlans = [
  {
    name: "Landing Page",
    price: "desde EUR 490 + IVA",
    category: "Web",
    desc: "Página única para campanhas, profissionais, serviços e geração de leads.",
    features: ["Design responsivo", "Formulário e WhatsApp", "Analytics e Meta Pixel", "SEO técnico básico", "SSL e publicação"],
  },
  {
    name: "Website Business",
    price: "desde EUR 890 + IVA",
    category: "Web",
    desc: "Website institucional até 5 páginas para empresas que precisam vender confiança.",
    features: ["Home, empresa, serviços, portfólio e contacto", "SEO básico", "Maps e redes sociais", "Painel para leads"],
  },
  {
    name: "Website Business Pro",
    price: "desde EUR 1.490 + IVA",
    category: "Web + Systems",
    desc: "Website com infraestrutura comercial, conteúdo, leads e integrações.",
    features: ["5-10 páginas", "CMS e blog", "Automação de formulários", "Integração com CRM", "Dashboard e relatórios"],
  },
  {
    name: "Ecommerce Start",
    price: "desde EUR 1.490 + IVA",
    category: "Ecommerce",
    desc: "Loja online de entrada para catálogos enxutos e validação comercial.",
    features: ["Até 30 produtos", "Pagamentos", "Gestão de encomendas", "Analytics"],
  },
  {
    name: "Ecommerce Pro",
    price: "desde EUR 2.490 + IVA",
    category: "Ecommerce",
    desc: "Ecommerce com operação, tracking e integrações para crescer com mais controlo.",
    features: ["MB Way e Multibanco", "Recuperação de carrinho", "Transportadora", "Faturação", "Google Merchant"],
  },
  {
    name: "Automação simples",
    price: "EUR 290-EUR 590 + IVA",
    category: "Automation & AI",
    desc: "Automação pontual para remover uma tarefa repetitiva simples.",
    features: ["Formulário para email", "Lead para CRM", "Notificação WhatsApp", "Follow-up básico"],
  },
  {
    name: "Automação Business",
    price: "EUR 690-EUR 1.490 + IVA",
    category: "Automation & AI",
    desc: "Fluxos com várias etapas, regras e integrações para equipas comerciais ou operacionais.",
    features: ["Qualificação de leads", "Propostas automáticas", "Integrações multi-ferramenta", "Relatórios"],
  },
  {
    name: "Automação personalizada",
    price: "desde EUR 1.500 + IVA",
    category: "Automation & AI",
    desc: "Automações e IA desenhadas para processos específicos da empresa.",
    features: ["IA para atendimento", "Análise de documentos", "Suporte interno", "Fluxos sob medida"],
  },
];

const recurringPlans = [
  {
    name: "Care",
    price: "EUR 39/mês + IVA",
    features: ["Hosting", "SSL", "Backup", "Monitorização", "Atualizações", "Suporte básico"],
  },
  {
    name: "Business",
    price: "EUR 99/mês + IVA",
    features: ["Hosting", "SSL", "Backup", "Monitorização", "Atualizações", "Suporte prioritário", "1h/mês de alterações", "Analytics", "Relatório"],
  },
  {
    name: "Growth",
    price: "EUR 249/mês + IVA",
    features: ["Hosting", "SSL", "Backup", "Monitorização", "Atualizações", "Suporte prioritário", "3h/mês de alterações", "Analytics", "Relatório", "Melhoria contínua"],
  },
];

const techPartnerOffer = {
  name: "BezierClick Tech Partner",
  price: "EUR 490/mês + IVA",
  additionalHour: "EUR 60/h + IVA",
  summary:
    "Parceiro tecnológico recorrente para PMEs que precisam evoluir websites, sistemas, automações e integrações sem contratar uma equipa interna.",
  includes: [
    "5 horas de desenvolvimento/mês",
    "Suporte prioritário",
    "Manutenção website",
    "Consultoria tecnológica",
    "Pequenas automações",
    "Analytics",
    "Integrações",
    "Backups e monitorização",
    "Reunião mensal",
    "Planeamento tecnológico",
  ],
};

const problemPaths = [
  {
    title: "Empresa não aparece no Google",
    desc: "A presença digital existe, mas não gera procura qualificada nem confiança nas pesquisas certas.",
    solution: "Website + SEO + SEO Local",
    cta: "Ver solução",
    href: "/solucoes",
    icon: Globe2,
  },
  {
    title: "Pedidos chegam pelo WhatsApp e perdem-se",
    desc: "Contactos, pedidos e seguimentos ficam espalhados, dificultando resposta e fecho comercial.",
    solution: "CRM + Automação",
    cta: "Ver solução",
    href: "/solucoes",
    icon: MessagesSquare,
  },
  {
    title: "Funcionários fazem processos repetitivos",
    desc: "A equipa perde horas em tarefas manuais que poderiam acontecer de forma automática e mensurável.",
    solution: "Automação empresarial",
    cta: "Ver solução",
    href: "/solucoes",
    icon: Workflow,
  },
  {
    title: "Informações são copiadas manualmente entre sistemas",
    desc: "Dados duplicados aumentam erros, atrasos e falta de visibilidade sobre a operação.",
    solution: "Integrações",
    cta: "Ver solução",
    href: "/solucoes",
    icon: Link2,
  },
  {
    title: "Empresa precisa de uma ferramenta específica",
    desc: "As ferramentas prontas já não acompanham o processo real da empresa ou criam trabalho extra.",
    solution: "Software à medida",
    cta: "Ver solução",
    href: "/solucoes",
    icon: DatabaseZap,
  },
  {
    title: "Atendimento demora",
    desc: "Pedidos simples demoram a ser respondidos e oportunidades arrefecem antes de chegar à equipa certa.",
    solution: "Automação + IA",
    cta: "Ver solução",
    href: "/solucoes",
    icon: Bot,
  },
];

const diagnosticOptions = [
  "Preciso de um website",
  "Meu website não gera clientes",
  "Quero vender online",
  "Quero aparecer melhor no Google",
  "Quero automatizar processos",
  "Preciso de um software",
  "Quero implementar IA",
  "Não sei qual solução preciso",
];

const contactNeedTypes = ["Website", "Ecommerce", "System", "Automation & AI", "Tech Partner", "Not sure"];

const buildSolutionWhatsappLink = (solution) =>
  buildWhatsappLink(solution.message, `solution_${solution.n}`);

module.exports = {
  positioning,
  heroPrimaryCtas,
  heroSecondaryCta,
  mainPillars,
  solutionGroups,
  projectPlans,
  recurringPlans,
  techPartnerOffer,
  problemPaths,
  diagnosticOptions,
  contactNeedTypes,
  buildSolutionWhatsappLink,
};
